import React from 'react'
class EnabledVerticalMenuIconComponent extends React.Component {
  render () {
    return (
      <div style={styles.iconContent}>
        <img src={this.props.img} alt='true' style={styles.icon} />
        <span style={styles.enabledLabel}>{this.props.label}</span>
      </div>
    )
  }
}

const styles = {
  iconContent: {
    height: '80px',
    maxWidth: '60px'
  },
  icon: {
    marginTop: '10px',
    width: '32px',
    height: '36px',
    marginBottom: '-6px'
  },
  enabledLabel: {
    color: '#4880FF',
    marginLeft: '1px',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStyle: 'normal'
  },
  link: {
    textDecoration: 'none'
  }
}

export default EnabledVerticalMenuIconComponent
